import React from 'react';
import { useSelector } from 'react-redux';
import Bouton from '../../composant/UI/Bouton/Bouton';
import Logo from '../../composant/Logo/Logo';
import RubriquesNavigationAdmin from '../../composant/Navigation/RubriquesNavigationAdmin/RubriquesNavigationAdmin';
import RubriquesNavigationClient from '../../composant/Navigation/RubriquesNavigationClient/RubriquesNavigationClient';
import EnTete from '../EnTete/EnTete';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import { Link } from 'react-router-dom';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
import styles from './Menu.module.scss';
const Menu = (props) => {
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );

  let attachedClasses = [
    s.d_flex,
    s.flex_column,
    styles.Menu,
    styles.Fermer,
    styles.RubliquesNavigationScroll,
  ];

  let commutateurClasses = [];

  if (interfaceAdmin) {
    commutateurClasses.push(styles.CommutateurMenuAdmin);
  } else {
    commutateurClasses.push(styles.CommutateurMenu);
  }

  let iconeFleche = (
    <Bouton ajoutClass={styles.ckas} rond={true} type={type_btn.danger}>
      <BiArrowFromLeft size={15} />
    </Bouton>
  );

  let fondGris = [styles.FondGrisMenu];

  if (props.ouvert) {
    attachedClasses = [styles.Menu, styles.Ouvert];
    commutateurClasses.push(styles.CommutateurOuvert);
    iconeFleche = <BiArrowFromRight size={25} />;
  }
  return (
    <>
      <div
        className={[
          attachedClasses.join(' '),
          styles.RubliquesNavigationScroll,
        ].join(' ')}
      >
        {interfaceAdmin ? null : (
          <Link to={url.accueil}>
            <Logo />
          </Link>
        )}
        <div className={[].join(' ')}>
          <EnTete />
          <nav>
            {interfaceAdmin ? (
              <RubriquesNavigationAdmin />
            ) : (
              <RubriquesNavigationClient />
            )}
          </nav>
        </div>
        {interfaceAdmin ? (
          <Link to={url.projet}>
            <Logo />
          </Link>
        ) : null}
      </div>
      <span
        className={commutateurClasses.join(' ')}
        onClick={props.commutateur}
      >
        {iconeFleche}
      </span>
      <span className={fondGris} onClick={props.commutateur} />
    </>
  );
};

export default Menu;
